<template>
    <div class="wrap opti_wrap" :class="{pd110: btnFixed}" id="app">
        <img class="closeBtn" id="closeBtn" src="https://resource.0168.net.cn/activity-mall/h5/theme16/ic-confirm-close.png" onclick="window.history.go(-1)">
        <div class="content" id="content">
            <div class="descDiv" id="descDiv">
                <div class="descTitle" id="descTitle">活动规则</div>
            </div>
            <div class="contentText" id="contentText">
                
                <p>1、活动对象：2G/3G/4G/5G手机用户。</p>
                <p>2、活动内容：活动期间凡首次在本页面成功开通业务（业务资费：6元起/月，具体资费以短信为准）即可每月从腾讯视频VIP、爱奇艺VIP等热门权益中任选一种兑换领取和随机话费红包任性送（仅开通当月享有一次机会）。</p>
                <p>热门权益（15选1)：腾讯视频VIP月卡、优酷视频黄金会员月卡、爱奇艺黄金会员月卡、芒果TV会员月卡、PP视频会员月卡、哔哩哔哩会员月卡、网易云音乐黑胶会员月卡、QQ音乐绿钻豪华版月卡、酷狗音乐豪华VIP月卡、酷我音乐会员月卡、掌阅VIP月卡、知乎盐选会员月卡、Keep健身会员月卡、喜马拉雅VIP月卡、懒人听书会员月卡。</p>
                <p>3、礼品发放：</p>
                <p>（1）热门权益兑换方式：进入<a href="https://mf.0168.net.cn/benefit-platform">https://mf.0168.net.cn/benefit-platform</a>，登录后，选择您需要的权益进行兑换。</p>
                <p>（2）话费权益兑换方式：进入<a href="https://mf.0168.net.cn/benefit-platform">https://mf.0168.net.cn/benefit-platform</a>，登录后，选择话费面值，点击“立即兑换”即可直充到账。</p>
                <p>温馨提示：使用相关权益时，请遵守相应平台的用户服务协议和权益使用协议，如违反相关协议规定，运营商和联合权益提供方均有权单独进行处理，包括但不限于中止或终止提供其所属平台的服务及要求侵权赔偿等。</p>
                <p>4、注意事项：</p>
                <p>（1）每个手机号仅限参与一次，如当月不退订，次月自动续订；</p>
                <p>（2）本业务退订后视作放弃本活动福利礼品，未充值到账或未兑换的礼品将不再发放（福利礼品包括会员、代金券、话费等）；</p>
                <p>（3）已开通本业务的老用户不可再次参与本次推广活动。</p>
                <p>（4）权益领取周期为自然月，热门权益需用户手动领取，如当月热门权益未领取，次月无法补领上月权益，请及时领取。</p>
                <p>（5）未退订状态下，权益连续下发12个月；如发生退订，则次月起不再发放该权益。</p>
                <p>（6）此权益兑换活动仅适用于专属互联网渠道订购成功用户。</p>
                <p>5、退订方式：</p>
                <p>（1）联通退订方式：进入中国联通APP-服务-我已订购-增值业务-选择相关业务名称-退订，或者发送短信0000至10010，按提示内容退订； </p>
                <p>（2）移动退订方式：发送短信0000至10086，按提示内容退订。 </p>
                <p>（3）电信退订方式：发送短信00000至10001，按提示内容退订。</p>
                <p>6、由于产品价格可能出现临时调整，具体资费以实际扣费短信为准。</p>
                <p>7、如有疑问可致电客服热线：<a href="tel:4008008663">4008008663</a>进行咨询。</p>    
            </div>
        </div>
    <div id="linkGZH" style="text-align: center; margin: 0px auto;"><a href="https://mf.0168.net.cn/benefit-platform/" style="color: rgb(0, 0, 81); font-size: 12px;">福利兑换中心</a></div>
    </div>
</template>

<script>
import 'common/css/reset.css';
import 'common/css/swiper.min.css'
import msgBox from "components/MessageBox.vue"
import quitModal from "components/QuitModal.vue"
import recomBox from "components/RecomBox.vue"


import $ from 'jquery'
import baseMethod from 'common/js/baseMethod.js'

export default {
    name: 'product',
    components: {
        "qs-msg-box" : msgBox,
        "qs-quit-modal" : quitModal,
        "qs-recom-box": recomBox

    },
    created(){
        var _this = this;

        _this.channelid = baseMethod.getQueryString("channelid") ? baseMethod.getQueryString("channelid") : '18000000';
        _this.unionSite = baseMethod.getUnionSite();
        _this.advertId = baseMethod.getAdvertId();

        _this.productId = baseMethod.getQueryString("product") ? baseMethod.getQueryString("product") : "XWPBM1Q74";
        _this.group = baseMethod.getQueryString("group");
        _this.topImgSrc = "https://resource.0168.net.cn/activity-mall/woread/theme1/top_all.jpg";
        _this.quitToUrl = _this.quitToUrl + "?channelid=" + _this.channelid; 

        _this.init();
        _this.getPageUrl();
        window.addEventListener('scroll', this.bindScroll);

        setTimeout(function(){
            _this.flag2s = false;
        }, 1500);

        setTimeout(function(){
            _this.indexshow = false;
        }, 2500);


        //本地缓存取和裕订单号
        if(localStorage.getItem("hy_order_expire") && localStorage.getItem("hy_order_expire") > new Date().getTime()){
            //没有过期 跳转至结果页
            var orderId = localStorage.getItem("hy_order_id");
            window.parent.location.href="https://store.0168.net.cn/activity-mall/cl/result_hy.html?orderId=" + orderId;
        }
    },
    data(){
        return {
            indexshow: true,
            flag2s: true,
            topImgSrc: "",
            inputBgImgSrc: "https://resource.0168.net.cn/activity-mall/h5/theme3/input_bg.jpg",
            inputBgImgSrc1_2:  "https://resource.0168.net.cn/activity-mall/h5/theme3/input_bg1.jpg",
            productName: "",
            visibleNotes: true,
            showQuestion: false,
            showPrivacy: true,
            isDis: false,
            isLoading: false,
            msg: '加载中。。。',
            flag: false,
            phonenum: '',
            channelid: '',
            unionSite: '',
            wokey: '',
            advertId: '',
            productId: '',
            group: '',
            trace: '',
            capUrl:'',
            productUrl: '',
            btnFixed: false,
            showQuitModal: false,
            showRecomBox: false,
            recomProduct: "",
            recomUrl: "",
            quitActivityImgSrc: "https://resource.0168.net.cn/activity-mall/5Gn/image/5Gn_activity.png",
            quitBtnImgSrc:"https://resource.0168.net.cn/activity-mall/5Gn/image/5Gn_get_btn.png",
            quitToUrl:"https://store.0168.net.cn/activity-mall/5Gn/index.html",
            getInfo: [
                '130 **** 9493 已领取爱奇艺会员 &nbsp;&nbsp;&nbsp;&nbsp;2分钟前',
                '155 **** 9512 已领取芒果TV会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;2分钟前',
                '130 **** 2181 已领取饿了么超级会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;3分钟前',
                '132 **** 3279 已领取腾讯会员 &nbsp;&nbsp;&nbsp;&nbsp;4分钟前',
                '132 **** 6917 已领取爱奇艺黄金会员 &nbsp;&nbsp;&nbsp;&nbsp;5分钟前',
                '155 **** 5511 已领取芒果TV会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;5分钟前',
                '131 **** 7510 已领取爱奇艺黄金会员 &nbsp;&nbsp;&nbsp;&nbsp;6分钟前',
                '131 **** 1495 已领取百度网盘会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;7分钟前',
                '130 **** 1043 已领取爱奇艺会员 &nbsp;&nbsp;&nbsp;&nbsp;9分钟前',
                '186 **** 1905 已领取哔哩哔哩会员月卡 &nbsp;&nbsp;&nbsp;&nbsp;9分钟前',
                '155 **** 2309 已领取优酷视频会员 &nbsp;&nbsp;&nbsp;&nbsp;10分钟前',
            ],
            checked: false,
            timesCount: 0,
            captcha: '',
            mode: "0",
            data: {},
            mifaChannel: ['450001', '410001', '420001'],
            youzhengChannel: ['680001','680002'],
            orderId: "",
            step: 1
        };
    },
    watch:{
        phonenum(now, old) {
            if (now.length == 11 && old.length == 10 && !baseMethod.isGuangdiantongChannel(this.channelid)) {
                var _this = this;
                _this.checked = true;
                _this.bindOpen();
            }
        }
    },
    methods:{
        bindScroll() {
            this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
            if (this.scrollHeight > 600) {
                this.btnFixed = true
            } else {
                this.btnFixed = false
            }
        },
        togg() {
           return this.isDis === false ? 'display:none' : 'display:block'
        },
        bindOpen() {
            let _this = this;

            if(!_this.checked){
                    _this.showMsg("请勾选同意隐私协议及相关条款");
                    return;
            }

            if(_this.timesCount != 0 ){
                 if (baseMethod.isEmpty(_this.captcha)) {
                    _this.showMsg("验证码不能为空！");
                    return;
                }
                _this.subCode();
                return;
            }

            if(_this.btnFixed){
                document.getElementById('inputPhone').focus();
                return;
            }
            
            if (!baseMethod.isMobile(_this.phonenum)) {
                _this.showMsg("请输入正确的手机号码");
                return;
            }

            let params = {
                product: _this.productId,
                channel_id: _this.channelid,
                tel: _this.phonenum,
                advert_id: _this.advertId,
                union_site: _this.unionSite,
                wokey: _this.wokey,
                request: window.location.href,
                preelection: _this.productUrl
            }
            
            _this.isDis = true;
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/product/v2/payment',
                type: 'get',
                dataType: 'json',
                data: params,
                success: function(res) {
                    _this.isDis = false;
                    if (res.code.startsWith("01")) {
                        _this.mode="1";
                        _this.capUrl = res.data.pay_url;
                        _this.step=0;
                        $("#cap").slideDown(500);
                    } else if (res.code.startsWith("02")) {
                        _this.mode="3";
                        _this.step=2;
                        _this.orderId = res.order_id;
                        _this.timesCount = 60;
                         const time = setInterval(() => {
                            if (_this.timesCount == 0) {
                                clearInterval(time)
                            } else {
                                _this.timesCount --;        
                            }
                        }, 1000)
                    } else if (res.code.startsWith("04")){
                        window.location.href = res.data.pay_url;
                        //保存订单号  created查询订单状态
                        localStorage.setItem('hy_order_id', res.order_id);
                        localStorage.setItem('hy_order_expire', new Date().getTime() + 3*60*1000);

                    } else if (res.code.startsWith("07")){
                        window.location.href = res.data.pay_url;
                    } else {
                        _this.isDis = false;
                        _this.showMsg(res.msg);
                    }
                },
                error: function(res) {
                    _this.isDis = false;
                    _this.showMsg("系统繁忙，请稍后再试！");
                }
            })
        },
        subCode(){
            let _this = this;

            if(_this.btnFixed){
                document.getElementById('inputPhone').focus();
                return;
            }
            
            if (!baseMethod.isMobile(_this.phonenum)) {
                _this.showMsg("请输入正确的手机号码");
                return;
            }
            let params = {
                "order_id": _this.orderId,
                "code": _this.captcha
            };
            _this.isDis = true;
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/product/code',
                type: 'post',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json'
                },
                 success: function(res) {
                    _this.isDis = false;
                    if (res.code.startsWith("5") || res.code.startsWith("4")) {
                        _this.showMsg(res.msg);
                    } else if(res.code.startsWith("6")){
                        _this.showMsg(res.msg);
                        window.parent.location.href = res.returl;
                    } else if (res.code == '00000'){
                        window.parent.location.href = res.returl;
                    }
                },
                error: function(res) {
                    _this.isDis = false;
                    _this.showMsg("系统繁忙，请稍后再试！");
                }
            });
        },
        agreePrivacy(){
            var _this = this;
            _this.checked = true;
            _this.showPrivacy = true;
        },
        showPrivacyBoxOrNot(){
            var _this = this;
            _this.showPrivacy= !_this.showPrivacy;
        },
        iKnow(){
            var _this = this;
            _this.checked = true;
            _this.onFoucs();
        },
        showMsg(msg){
            var _this = this;
            _this.isLoading = true;
            _this.msg = msg;

            setTimeout(function(){
                _this.isLoading = false;
            },1000)
        },
        closeQuitModal(){
            var _this = this;
            _this.showQuitModal = false;
        },
        closeRecomBox(){
            var _this = this;
            _this.showRecomBox = false;
        },
        showActivityOrNot(){
            var _this = this;
            _this.visibleNotes = !_this.visibleNotes;
        },
        onFoucs(){
            document.getElementById('inputPhone').focus();
            return;
        },
        init() {
            var _this = this;
            let params = {
                advert_id: _this.advertId
            }
            $.ajax({
                url: 'https://api.0168.net.cn/qiaosi/order/v3/init',
                type: 'get',
                data: params,
                dataType: "json",
                headers: {
                    'Content-Type': 'application/json'
                },
                success: function(res) {
                    console.log(res.data);
                }
            })
        },
        getPageUrl(){
            var _this = this;
            var param = {
                product: _this.productId,
                channelid: _this.channelid,
                advertId: _this.advertId,
                unionSite: _this.unionSite
            };

            //调试阶段
            if(_this.isDebug == 1 && baseMethod.getQueryString("ip")){
                param['ip'] = baseMethod.getQueryString("ip");
                param['isDebug'] = _this.isDebug;
            }

            if(localStorage.getItem('url') && localStorage.getItem("url_expire") > new Date().getTime()){
                _this.productUrl = localStorage.getItem('url')
            } else {
                $.ajax({
                  url: 'https://api.0168.net.cn/qiaosi/page/v1',
                  type: 'get',
                  data: param,
                  success: function(res){
                      var toUrl = res.data;
                      localStorage.setItem('url', toUrl);
                      localStorage.setItem('url_expire', new Date().getTime() + 30*24*60*60*1000);
                      _this.productUrl = res.data;
                  }
                });
            }
        }

    }
}
</script>

<style scoped>
    body {
        height: 100%;
    }

    #app {
        width: auto;
        background-color:  #02c617;
        padding: 4rem 0.85rem 2rem 0.85rem;
    }

    div {
        margin: 0;
        padding: 0;
    }

    img {
        display: block;
        margin: 0;
        padding: 0;
        border: 0;
    }


   @media screen and (min-width: 500px) {
            html, body {
                width: 500px;
                margin: 0 auto;
                padding: 0;
                text-align: center;
                background: white;
            }
            #app, .app {
                position: relative;
                width: 500px;
                padding: 4rem 1rem 2rem 1rem;
                background: var(--bgColor);
            }
        }

        .content {
            width: 100%;
            background-color: #FDF9E3;
            border-radius: 10px;
            top: 2rem;
            padding-top: 10px;
            margin-bottom: 1rem;
        }

        .contentText {
            line-height: 24px;
            padding: 2rem 1rem;
            color: #3A3A3A;
            font-size: 14px;
            text-align: left;
        }

        .closeBtn {
            position: absolute;
            top: 1rem;
            right: 1rem;
        }

        .descDiv {
            text-align: center;
            position: absolute;
            z-index: 2;
            width: calc(100% - 20px);
        }

        .descTitle {
            width: 45%;
            margin: -2rem auto 0;
            background: #FFC72C;
            border-radius: 50px;
            font-size: 18px;
            padding: 0.65rem 0;
            font-weight: bold;
        }

        a {
            text-decoration: underline;
        }
</style>


// WEBPACK FOOTER //
// ThemeAqyActivity.vue?3ca6aebd